import classNames from 'classnames'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './LinkWithIcon.module.scss'
import { SvgChevron as DefaultIcon } from '../../svg-icons'

function LinkWithIcon({
  to,
  icon,
  children,
  isExternal,
  isTargetBlank,
  isReversed,
  className,
  ...rest
}) {
  const IconComponent = icon || DefaultIcon

  return isExternal ? (
    <a
      href={to}
      className={classNames(
        styles.link,
        isReversed && styles.reversed,
        className
      )}
      target={isTargetBlank && '_blank'}
      rel={isTargetBlank && 'noopener noreferrer'}
      {...rest}
    >
      {children}

      <IconComponent className={styles.icon} />
    </a>
  ) : (
    <Link
      to={to}
      className={classNames(
        styles.link,
        isReversed && styles.reversed,
        className
      )}
      {...rest}
    >
      {children}

      <IconComponent className={styles.icon} />
    </Link>
  )
}

LinkWithIcon.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
  isExternal: PropTypes.bool,
  isTargetBlank: PropTypes.bool,
  isReversed: PropTypes.bool,
  icon: PropTypes.elementType,
}

export default LinkWithIcon
